import { ref } from 'vue';
import { useModal } from 'vue-final-modal';
import { useCustomToast } from '@/shared/lib';
import { ConfirmDeleteModal } from '@/shared/ui';
import { trainingMatrixApi } from '@/entities/Training';

const CONFIRM_TITLE = 'Tem certeza que deseja deletar a Matriz de treinamento do cargo?';
const CONFIRM_DESCRIPTION = 'A ação não pode ser desfeita.';

export function useDeleteTrainingMatrixPositionEntries(
  onDeleted: (positionId: number) => Promise<void> | void
) {
  const toast = useCustomToast();
  const isDeleting = ref(false);
  let pendingPositionId = 0;

  const { open: openModal, close: closeModal } = useModal({
    component: ConfirmDeleteModal,
    attrs: {
      title: CONFIRM_TITLE,
      description: CONFIRM_DESCRIPTION,
      onClose: () => closeModal(),
      onConfirm: () => performDelete(),
    },
  });

  function requestDelete(positionId: number): void {
    pendingPositionId = positionId;
    openModal();
  }

  async function performDelete(): Promise<void> {
    const positionId = pendingPositionId;
    closeModal();
    isDeleting.value = true;
    try {
      await trainingMatrixApi.deletePositionEntries(positionId);
      toast.showSuccessToast({ title: 'Matriz deletada com sucesso.', type: 'success' });
      await onDeleted(positionId);
    } catch {
      toast.showErrorToast({
        title: 'Erro ao deletar Matriz, tente novamente.',
        type: 'error',
      });
    } finally {
      isDeleting.value = false;
    }
  }

  return {
    isDeleting,
    requestDelete,
  };
}
